/** 厂商设备统一元数据（计价 / 非计价共用字段） */
export interface VendorDeviceMeta {
  vendor?: string;
  vendorID?: string;
  device?: string;
  deviceID?: string;
  deviceType?: string;
  billItemId?: string;
  /** 计费项 relation.config.quantityUnit，询价 / 数量展示单位 */
  quantityUnit?: string;
}

export const VENDOR_DEVICE_FIELD_KEYS = ['vendor', 'vendorID', 'device', 'deviceID', 'deviceType', 'billItemId', 'quantityUnit'] as const;

/** 磁盘类能力块计价上下文（resourceCode 由交付类型 resourceConfigs 注入） */
export interface DiskPricingCapabilityOptions {
  billModelId?: string;
  /** 交付类型 id，计价 resolve 必传 */
  deploymentTypeId?: string;
  resourceCode?: string;
  /** 付费时机；后付费时容量/数量非必填 */
  paymentTiming?: string;
  /** SKU 类型；custom + sku-create 时容量非必填 */
  skuType?: string;
  /** 资源编辑模式；仅 sku-create 放宽容量必填 */
  resourceEditMode?: string;
}

export function isDiskPricingActive(
  options?: DiskPricingCapabilityOptions,
): options is DiskPricingCapabilityOptions & { billModelId: string; resourceCode: string } {
  return Boolean(options?.billModelId && options?.resourceCode);
}

/** 弹窗 / 磁盘记录内厂商设备字段前缀 */
export const DISK_PRICING_FIELD = 'pricing';
